import type React from 'react'

import { BillingDetailBanner, PaymentFailedBanner } from './components'
import css from './styles.module.css'
import { useInfoBanner } from './useInfoBanner'

export const InfoBannerWrapper: React.FC = () => {
  const { displayBraintreeAlert, displayPaymentFailedBanner } = useInfoBanner()

  // Each banner stands on its own condition. The wrapper used to demand all of
  // them at once — negations joined by `||`, landed by accident in OCT-4487 —
  // so a user matching one banner saw nothing at all.
  if (!displayBraintreeAlert && !displayPaymentFailedBanner) {
    return null
  }

  return (
    <div className={css.info_banner_wrapper}>
      {displayPaymentFailedBanner && <PaymentFailedBanner />}
      {displayBraintreeAlert && <BillingDetailBanner />}
    </div>
  )
}
